import type { RouteType } from "../../shared/stepConfig";
import type { IconName } from "../components/Icon";
import { ROUTE_TYPE_ICONS, ROUTE_TYPE_LABELS } from "./routeTypeDisplay";

export type TriggerType = "scheduled" | RouteType;

export const triggerTypeOrder: readonly TriggerType[] = [
  "scheduled",
  "webhook",
  "api",
  "webpage",
  "other",
];

export const triggerTypeLabels: Record<TriggerType, string> = {
  scheduled: "Scheduled",
  ...ROUTE_TYPE_LABELS,
};

export const triggerTypeIcons: Record<TriggerType, IconName> = {
  scheduled: "clock",
  ...ROUTE_TYPE_ICONS,
};

type TriggerBranch = {
  name: string;
  headCommit?: {
    schedules?: readonly { cronExpression: string }[];
    routes?: readonly { routeType: string | null }[];
  } | null;
};

function liveHeadCommit(branches: readonly TriggerBranch[] | undefined) {
  return branches?.find((b) => b.name === "main")?.headCommit ?? null;
}

export function workflowScheduleCrons(
  branches: readonly TriggerBranch[] | undefined
): string[] {
  return (liveHeadCommit(branches)?.schedules ?? []).map(
    (s) => s.cronExpression
  );
}

export function workflowTriggerTypes(
  branches: readonly TriggerBranch[] | undefined
): TriggerType[] {
  const headCommit = liveHeadCommit(branches);
  if (!headCommit) return [];
  const present = new Set<TriggerType>();
  if ((headCommit.schedules?.length ?? 0) > 0) present.add("scheduled");
  for (const route of headCommit.routes ?? []) {
    if (route.routeType) present.add(route.routeType as RouteType);
  }
  return triggerTypeOrder.filter((type) => present.has(type));
}
